const { client, loadToken } = require('./client');
export { loadToken };

export async function getUser() {
    var { data } = await client.get(`/user`);

    return data;
}

export async function getUserByEmail(email) {
    var { data } = await client.get(`/user/${email}`);

    return data;
}

const all = {
    loadToken, getUser, getUserByEmail
};

export default all;